// Every new page entry begins at the banner; in-page purchase links still work.
(() => {
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  const clearEntryHash = () => {
    if (location.hash) history.replaceState(history.state, '', location.pathname + location.search);
  };
  const scrollToStart = () => window.scrollTo({top: 0, left: 0, behavior: 'instant'});
  clearEntryHash();
  let entryPending = true;
  const finishEntry = () => { if (entryPending) scrollToStart(); };
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => {
    addEventListener(type, () => { entryPending = false; }, {once: true, passive: true});
  });
  addEventListener('DOMContentLoaded', () => requestAnimationFrame(finishEntry), {once: true});
  addEventListener('pageshow', event => {
    if (event.persisted) { entryPending = true; clearEntryHash(); }
    finishEntry();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href="#top"]');
    if (link) { event.preventDefault(); clearEntryHash(); scrollToStart(); }
  });
  // Switching the preview into its mobile layout starts the review at the hero.
  matchMedia('(max-width: 760px)').addEventListener('change', event => {
    if (event.matches) { clearEntryHash(); scrollToStart(); }
  });
})();
